module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-news-mobile"
  }, [_c('div', {
    staticClass: "fzg-banner"
  }, [_c('fzg-menu'), _vm._v(" "), _c('img', {
    staticClass: "m-banner",
    attrs: {
      "src": require("../../assets/img2/mobile/news/banner.jpg"),
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "news-deal"
  }, [_c('img', {
    staticClass: "main-title",
    attrs: {
      "src": require("../../assets/img2/mobile/news/title_trans.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "deal-list"
  }, _vm._l((_vm.dealList), function(item) {
    return _c('a', {
      staticClass: "deal-item",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "logo-area"
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": item.banner
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "fzg-recent-activity"
  }, [_c('a', {
    attrs: {
      "name": "activity"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "activity-title",
    attrs: {
      "src": require("../../assets/img2/mobile/news/title_activity.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fzg-activity-wrap"
  }, [_c('div', {
    staticClass: "activity-left"
  }, [_c('a', {
    attrs: {
      "href": _vm.firstActivityNews.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.firstActivityNews.banner,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-title-area"
  }, [_c('div', {
    staticClass: "l-date"
  }, [_vm._v(_vm._s(_vm.firstActivityNews.date) + " ")]), _vm._v(" "), (_vm.firstActivityNews.title) ? _c('div', {
    staticClass: "l-title"
  }, [_vm._v(_vm._s(_vm.firstActivityNews.title.length > 50 ? _vm.firstActivityNews.title.substr(0, 50) + '...' : _vm.firstActivityNews.title))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "activity-right"
  }, _vm._l((_vm.activityNewsList), function(item, index) {
    return (index > 0 && index < 4) ? _c('div', {
      staticClass: "right-item"
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "r-item-date"
    }, [_vm._v(_vm._s(item.date) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "r-item-title"
    }, [_vm._v(_vm._s(item.title.substr(0, 40)))]), _vm._v(" "), _c('div', {
      staticClass: "r-item-content"
    }, [_vm._v(_vm._s(item.brief.length > 50 ? item.brief.substr(0, 50) + '...' : item.brief))])])]) : _vm._e()
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "fzg-activity"
  }, [_c('img', {
    staticClass: "title-activity",
    attrs: {
      "src": require("../../assets/img2/mobile/news/title_news.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activity-area"
  }, _vm._l((_vm.groupNewsList), function(item) {
    return _c('a', {
      staticClass: "act-item",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "act-icon"
    }, [_c('img', {
      attrs: {
        "src": item.banner
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right-content"
    }, [_c('div', {
      staticClass: "act-title"
    }, [_vm._v(_vm._s(item.title))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "page-num"
  }, _vm._l((_vm.groupNewsPageData.total_page), function(page) {
    return _c('span', {
      class: {
        'active': page == _vm.currentNewsPage
      },
      on: {
        "click": function($event) {
          _vm.changeNewsPage(page)
        }
      }
    }, [_vm._v(" " + _vm._s(page))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c5c3dc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/FzgNewsMobile.vue
// module id = 218
// module chunks = 0